var LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

function wishlistNumUpdate(wishnum) {

  if (wishnum > 0) {
    $('.site_wishlist_num').removeClass('hide');
    // 	$('.site_wishlist_num').show();
    $('.site_wishlist_num').text(wishnum);
  }
}

document.addEventListener('shopify-wishlist:updated', function (event) {
  initGrid();
  let wishnum = event.detail.wishlist.length;
  wishlistNumUpdate(wishnum);
});

document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
  let wishnum = event.detail.wishlist.length;
  wishlistNumUpdate(wishnum);
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    var productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', function () {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      if ($(this).hasClass('active')) {
        $(this).closest('.grid-item__content').find('.main-popup .quick_msg').text('Added To Wishlist');
        $(this).closest('.grid-item__content').find('.main-popup').css('visibility', 'visible');
        setTimeout(function () {
          $('.main-popup').css('visibility', 'hidden');
        }, 1000);
      }
      else {
        $(this).closest('.grid-item__content').find('.main-popup .quick_msg').text('Removed From Wishlist');
        $(this).closest('.grid-item__content').find('.main-popup').css('visibility', 'visible');
        setTimeout(function () {
          $('.main-popup').css('visibility', 'hidden');
        }, 1000);
      }
    });
  });
};

var initGrid = function () {
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setWishlist = function (array) {
  var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

var updateWishlist = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  return wishlist.indexOf(handle) !== -1;
};

var resetWishlist = function () {
  return setWishlist([]);
};


// ============================ Add To Cart ============================
var Btns = {
  quickAddBtn: ".js-quick-add-btn",
  quickAddForm: ".js-quick-add-form",
  quickAddHolder: "#QuickAddHolder",
};

// On Click Open Product Model
var modalInitailized = false;
var modal;

if (!modalInitailized) {
  modal = new theme.Modals("QuickAddModal", "quick-add");
  modalInitailized = true;

  // Empty cart form when closed
  document.addEventListener(
    "modalClose.QuickAddModal",
    function () {
      setTimeout(
        function () {
          $(Btns.quickAddHolder).html('');
        }.bind(this),
        350
      );
    }.bind(this)
  );
}

$(document).on("click", Btns.quickAddForm, function (evt) {
  $(Btns.quickAddHolder).html('');
  var btn = evt.currentTarget;
  var gridItem = btn.closest(".grid-product");
  var handle = gridItem.getAttribute("data-product-handle");
  var prodId = gridItem.getAttribute("data-product-id");
  var url = theme.routes.home + "/products/" + handle + "?view=form";

  // remove double `/` in case shop might have /en or language in URL
  url = url.replace("//", "/");

  fetch(url)
    .then(function (response) {
      return response.text();
    })
    .then(
      function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var div = doc.querySelector('.product-section[data-product-handle="' + handle + '"]');

        $(Btns.quickAddHolder).append(div);

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        window.dispatchEvent(
          new CustomEvent("quickadd:loaded:" + prodId)
        );

        document.dispatchEvent(
          new CustomEvent("quickadd:loaded", {
            detail: {
              productId: prodId,
              handle: handle,
            },
          })
        );

        modal.open();
      }.bind(this)
    );

});


// Add To Cart Click Event
$(document).on("click", Btns.quickAddBtn, function (evt) {
  var btn = evt.currentTarget;
  btn.classList.add("btn--loading");
  var id = btn.dataset.id;
  var data = {
    items: [
      {
        id: id,
        quantity: 1,
      },
    ],
  };

  fetch(theme.routes.cartAdd, {
    method: "POST",
    body: JSON.stringify(data),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(
      function (data) {
        if (data.status === 422 || data.status === "bad_request") {
        } else {
          var product = data;
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: {
                product: product,
                addToCartBtn: btn,
              },
            })
          );
        }
        btn.classList.remove("btn--loading");
      }.bind(this)
    );
});